import _ from "lodash";
// TODO: debemos optimizar la llamada a lodash: https://medium.com/bootstart/why-using-chain-is-a-mistake-9bc1f80d51ba
import {
  interpolateRgb,
  max,
  mean,
  min,
  nest,
  range,
  scaleLinear,
  sum,
  timeDay,
  timeMonday,
  timeMonth,
  timeYear,
  values,
} from "d3";
import { ema, rollingMaxMin, timeParseNull2 } from "@/_core/_helpers/_helpers";

export const ProcessData = function(_d3 = null) {
  this._d3 = _d3;
};

ProcessData.prototype.setintervalGroup = function(_context) {
  // When user changes 1W, 2W, etc intervals for Planning+Rates(topography)+M2M charts,
  // define date formats, calculate data and render charts
  _context.intervalGroup = _context.tIntervals[_context.pickedGroup]; // Selected Bucket or interval to group data
  _context.dateFormat = _context.tFormat[_context.intervalGroup];
  _context.datePrefix = _context.prefixOptions[_context.intervalGroup];
  _context.planningChartDataPortfolio = _context.planningChartDataRaw;
  _context.planningChartData = this.dataCompress(
    _context.planningChartDataRaw,
    _context.intervalGroup,
    _context,
  );
  _context.planningChartDataWhole = _context.planningChartData;
  _context.longFwdData = _context.longFwdDataWhole;
  _context.shortFwdData = _context.shortFwdDataWhole;
  _context.longCallData = _context.longCallDataWhole;
  _context.shortCallData = _context.shortCallDataWhole;
  _context.longPutData = _context.longPutDataWhole;
  _context.shortPutData = _context.shortPutDataWhole;
  let auxMinMax = JSON.parse(JSON.stringify(_context.minMaxYAxis));
  // Unica que podría afectar candlecharts
  _context.minMaxYAxis = _context.totalCurrencyExposure.calculateMinMaxYAxis(
    _context.candleChartData,
    _context.planningChartData,
    _context.showHideExposure,
    _context.showHideHedges,
    _context.showHideNet,
    _context.longFwdData,
    _context.showHideLongFwd,
    _context.shortFwdData,
    _context.showHideShortFwd,
    _context.longCallData,
    _context.showHideLongCall,
    _context.shortCallData,
    _context.showHideShortCall,
    _context.longPutData,
    _context.showHideLongPut,
    _context.shortPutData,
    _context.showHideShortPut,
  );
  _context.renderPortfolio = 1 + _context.renderPortfolio;
  _context.renderPlanning = 1 + _context.renderPlanning;
  _context.renderTopography = 1 + _context.renderTopography;
  _context.renderM2M = 1 + _context.renderM2M;
  if (
    auxMinMax[0] !== _context.minMaxYAxis[0] ||
    auxMinMax[1] !== _context.minMaxYAxis[1]
  ) {
    _context.renderCandle = 1 + _context.renderCandle;
  }
};

ProcessData.prototype.filterDerivatives = function(d, derivative, isLong) {
  if (d == null) {
    return false;
  }
  let result;
  if (isLong) {
    result =
      d.derivative === derivative &&
      (d.buy_sell === "buy" || d.buy_sell === "long");
  } else {
    result =
      d.derivative === derivative &&
      (d.buy_sell === "sell" || d.buy_sell === "short");
  }
  return result;
};

ProcessData.prototype.monthDiff = function(d1, d2) {
  // Months between two dates
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months += d2.getMonth() - d1.getMonth();
  return months <= 0 ? 0 : months;
};

ProcessData.prototype.quarterDate = function(date) {
  // Return the quarter that the variable "date" belongs to, for nesting
  const tod = new Date();
  const mDiff = this.monthDiff(tod, date);
  let newDate;
  if (mDiff === 0) {
    newDate = timeMonth(date);
  } else {
    var quarters = Math.floor(this.monthDiff(tod, date) / 3);
    newDate = timeDay(
      timeDay(tod.setMonth(tod.getMonth() + 3 * quarters + 1)).setDate(1),
    );
  }
  return newDate;
};

ProcessData.prototype.timeCompare = function(date, intervalGroup, data, pro) {
  // Nesting function, returns the appropriate date for nesting
  let dateCopy;
  let durfn;
  if (intervalGroup === "day") {
    durfn = timeDay(date);
  } else if (intervalGroup === "week") {
    durfn = timeMonday(date);
  } else if (intervalGroup === "weeks") {
    dateCopy = timeDay(timeParseNull2(JSON.parse(JSON.stringify(date))));
    if (date.getDate() < 15) {
      durfn = timeDay(dateCopy.setDate(1));
    } else {
      durfn = timeDay(dateCopy.setDate(15));
    }
  } else if (intervalGroup === "month") {
    durfn = timeMonth(date);
  } else if (intervalGroup === "quarter") {
    durfn = this.quarterDate(date, pro);
  } else if (intervalGroup === "semester") {
    dateCopy = timeDay(timeParseNull2(JSON.parse(JSON.stringify(date))));
    if (dateCopy.getMonth() < 6) {
      durfn = timeDay(timeDay(dateCopy.setMonth(0)).setDate(1));
    } else {
      durfn = timeDay(timeDay(dateCopy.setMonth(6)).setDate(1));
    }
  } else if (intervalGroup === "year") {
    if (date.getFullYear() === data[0].planned_expiration_date.getFullYear()) {
      durfn = timeDay(
        timeParseNull2(
          JSON.parse(JSON.stringify(data[0].planned_expiration_date)),
        ),
      );
    } else {
      durfn = timeYear(date);
    }
  } else if (intervalGroup === "all") {
    durfn = timeDay(
      timeParseNull2(
        JSON.parse(JSON.stringify(data[0].planned_expiration_date)),
      ),
    );
  }
  if (durfn < data[0].planned_expiration_date) {
    durfn = timeDay(
      timeParseNull2(
        JSON.parse(JSON.stringify(data[0].planned_expiration_date)),
      ),
    );
  }
  return durfn;
};

ProcessData.prototype.dataCompress = function(data, intervalGroup, _context) {
  // TODO: base currency change
  let pro = this;
  function setMax(data, xRange) {
    // Include the last date for x axis in xRange, used in Planning, Rates (topography) and M2M
    var xMax = timeDay(
      timeParseNull2(JSON.parse(JSON.stringify(xRange[xRange.length - 1]))),
    );
    if (intervalGroup === "day") {
      xMax.setDate(xMax.getDate() + 1);
    } else if (intervalGroup === "week") {
      xMax.setDate(xMax.getDate() + 7);
    } else if (intervalGroup === "weeks") {
      xMax.setDate(xMax.getDate() + 15);
    } else if (intervalGroup === "month") {
      xMax.setMonth(xMax.getMonth() + 1);
    } else if (intervalGroup === "quarter") {
      xMax.setMonth(xMax.getMonth() + 3);
    } else if (intervalGroup === "semester") {
      xMax.setMonth(xMax.getMonth() + 6);
    } else if (intervalGroup === "year") {
      xMax.setFullYear(xMax.getFullYear() + 1);
    } else if (intervalGroup === "all") {
      xMax = timeDay(
        timeParseNull2(
          JSON.parse(
            JSON.stringify(data[data.length - 1].planned_expiration_date),
          ),
        ),
      );
    }
    return timeDay(xMax);
  }

  var generatedData = nest()
    .key(function(d) {
      return pro.timeCompare(
        d.planned_expiration_date,
        intervalGroup,
        data,
        pro,
      );
    })
    .rollup(function(v) {
      // Date
      var planned_expiration_date = pro.timeCompare(
        values(v).pop().planned_expiration_date,
        intervalGroup,
        data,
        pro,
      );
      // Planning
      var balance = sum(v, function(d) {
        return d.balance;
      });
      var cash_flow = sum(v, function(d) {
        return d.cash_flow;
      });
      var strategy = sum(v, function(d) {
        return d.strategy;
      });
      var hedge = sum(v, function(d) {
        return d.notional_hedge;
      });
      var tot_cf = sum(v, function(d) {
        return d.cash_flow + d.balance;
      });
      // Rates
      var m2m_rate =
        sum(v, function(d) {
          return d.fwd_expo * (d.cash_flow + d.balance);
        }) / tot_cf;
      var hedge_rate =
        (sum(v, function(d) {
          return d.fwd_expo * d.notional_hedge;
        }) +
          sum(v, function(d) {
            return d.hedge_value_hedge;
          }) +
          sum(v, function(d) {
            return d.premium;
          })) /
        hedge;
      var net_rate =
        (sum(v, function(d) {
          return d.fwd_expo * (d.cash_flow + d.balance);
        }) +
          sum(v, function(d) {
            return d.hedge_value;
          }) +
          sum(v, function(d) {
            return d.premium;
          })) /
        tot_cf;
      // Mark to market
      var m2m = sum(v, function(d) {
        return d.fwd_expo * (d.cash_flow + d.balance);
      });
      var hedge_m2m = sum(v, function(d) {
        return d.hedge_value_hedge;
      });
      var net_m2m = m2m + hedge_m2m;
      // Derivatives
      var lFwd =
        sum(v, function(d) {
          return pro.filterDerivatives(d, "forward", true)
            ? d.strike * d.notional
            : 0;
        }) /
        sum(v, function(d) {
          return pro.filterDerivatives(d, "forward", true) ? d.notional : 0;
        });
      var sFwd =
        sum(v, function(d) {
          return pro.filterDerivatives(d, "forward", false)
            ? d.strike * d.notional
            : 0;
        }) /
        sum(v, function(d) {
          return pro.filterDerivatives(d, "forward", false) ? d.notional : 0;
        });

      var lCall =
        sum(v, function(d) {
          return pro.filterDerivatives(d, "call", true)
            ? d.strike * d.notional
            : 0;
        }) /
        sum(v, function(d) {
          return pro.filterDerivatives(d, "call", true) ? d.notional : 0;
        });

      var sCall =
        sum(v, function(d) {
          return pro.filterDerivatives(d, "call", false)
            ? d.strike * d.notional
            : 0;
        }) /
        sum(v, function(d) {
          return pro.filterDerivatives(d, "call", false) ? d.notional : 0;
        });

      var lPut =
        sum(v, function(d) {
          return pro.filterDerivatives(d, "put", true)
            ? d.strike * d.notional
            : 0;
        }) /
        sum(v, function(d) {
          return pro.filterDerivatives(d, "put", true) ? d.notional : 0;
        });
      var sPut =
        sum(v, function(d) {
          return pro.filterDerivatives(d, "put", false)
            ? d.strike * d.notional
            : 0;
        }) /
        sum(v, function(d) {
          return pro.filterDerivatives(d, "put", false) ? d.notional : 0;
        });

      return {
        planned_expiration_date: planned_expiration_date,
        balance: balance,
        cash_flow: cash_flow,
        strategy: strategy,
        hedge: hedge,
        m2m_rate: m2m_rate,
        hedge_rate: hedge_rate,
        net_rate: net_rate,
        m2m: m2m,
        hedge_m2m: hedge_m2m,
        net_m2m: net_m2m,
        lFwd: lFwd,
        sFwd: sFwd,
        lCall: lCall,
        sCall: sCall,
        lPut: lPut,
        sPut: sPut,
      };
    })
    .entries(data)
    .map(function(d) {
      return d.value;
    });

  // ================== Functions Calls ==========================
  // this.calculateAverages(data, _context);
  _context.xRange = generatedData.map((d) => d.planned_expiration_date);
  _context.xRange.push(setMax(data, _context.xRange));
  _context.xRangeWhole = _context.xRange;
  _context.zoomValue = [2, +_context.xRange.length];
  return generatedData;
};

ProcessData.prototype.calculateAverages = function(data) {
  var pro = this;
  pro.averages = {};
  // This averages will be shown in right sidebar (results bar) for all the data selected in zoom.
  let planned_expiration_date = "All";
  let balance = data.map((d) => d.balance).reduce(this.add, 0);
  let cash_flow = data.map((d) => d.cash_flow).reduce(this.add, 0);
  let strategy = data.map((d) => d.strategy).reduce(this.add, 0);
  let hedge = data.map((d) => d.notional_hedge).reduce(this.add, 0);
  let tot_cf = data.map((d) => d.balance + d.cash_flow).reduce(this.add, 0);
  let m2m_rate =
    data
      .map((d) => d.fwd_expo * (d.balance + d.cash_flow))
      .reduce(this.add, 0) / tot_cf;
  let hedge_rate =
    (data
      .map((d) => d.fwd_expo * d.notional_hedge + d.hedge_value_hedge)
      .reduce(this.add, 0) +
      data.map((d) => d.premium).reduce(this.add, 0)) /
    hedge;
  let net_rate =
    (data
      .map((d) => d.fwd_expo * (d.balance + d.cash_flow) + d.hedge_value_hedge)
      .reduce(this.add, 0) +
      data.map((d) => d.premium).reduce(this.add, 0)) /
    tot_cf;
  let m2m = data
    .map((d) => d.fwd_expo * (d.balance + d.cash_flow))
    .reduce(this.add, 0);
  let hedge_m2m = data.map((d) => d.hedge_value_hedge).reduce(this.add, 0);
  let net_m2m = m2m + hedge_m2m;

  // Derivatives
  let lFwd =
    data
      .map((d) =>
        pro.filterDerivatives(d, "forward", true) ? d.strike * d.notional : 0,
      )
      .reduce(this.add, 0) /
    data
      .map((d) => (pro.filterDerivatives(d, "forward", true) ? d.notional : 0))
      .reduce(this.add, 0);
  let sFwd =
    data
      .map((d) =>
        pro.filterDerivatives(d, "forward", false) ? d.strike * d.notional : 0,
      )
      .reduce(this.add, 0) /
    data
      .map((d) => (pro.filterDerivatives(d, "forward", false) ? d.notional : 0))
      .reduce(this.add, 0);

  let lCall =
    data
      .map((d) =>
        pro.filterDerivatives(d, "call", true) ? d.strike * d.notional : 0,
      )
      .reduce(this.add, 0) /
    data
      .map((d) => (pro.filterDerivatives(d, "call", true) ? d.notional : 0))
      .reduce(this.add, 0);
  let sCall =
    data
      .map((d) =>
        pro.filterDerivatives(d, "call", false) ? d.strike * d.notional : 0,
      )
      .reduce(this.add, 0) /
    data
      .map((d) => (pro.filterDerivatives(d, "call", false) ? d.notional : 0))
      .reduce(this.add, 0);

  let lPut =
    data
      .map((d) =>
        pro.filterDerivatives(d, "put", true) ? d.strike * d.notional : 0,
      )
      .reduce(this.add, 0) /
    data
      .map((d) => (pro.filterDerivatives(d, "put", true) ? d.notional : 0))
      .reduce(this.add, 0);
  let sPut =
    data
      .map((d) =>
        pro.filterDerivatives(d, "put", false) ? d.strike * d.notional : 0,
      )
      .reduce(this.add, 0) /
    data
      .map((d) => (pro.filterDerivatives(d, "put", false) ? d.notional : 0))
      .reduce(this.add, 0);

  pro.averages = {
    planned_expiration_date: planned_expiration_date,
    balance: balance,
    cash_flow: cash_flow,
    strategy: strategy,
    hedge: hedge,
    m2m_rate: m2m_rate,
    hedge_rate: hedge_rate,
    net_rate: net_rate,
    m2m: m2m,
    hedge_m2m: hedge_m2m,
    net_m2m: net_m2m,
    lFwd: lFwd,
    sFwd: sFwd,
    lCall: lCall,
    sCall: sCall,
    lPut: lPut,
    sPut: sPut,
  };
  return pro.averages;
};

ProcessData.prototype.add = function(accumulator, a) {
  return accumulator + a;
};

ProcessData.prototype.average = function(array) {
  return array.reduce((a, b) => a + b) / array.length;
};

ProcessData.prototype.onlyUnique = function(value, index, self) {
  return self.indexOf(value) === index;
}; // Return unique values

ProcessData.prototype.percentileNum = function(arr, val) {
  // Return Percentile
  return (
    arr.reduce((acc, v) => acc + (v < val ? 1 : 0) + (v === val ? 0.5 : 0), 0) /
    arr.length
  );
};

ProcessData.prototype.includeSpot = function(
  chartDataRaw,
  spot,
  changeFields = false,
) {
  var data = [];
  if (chartDataRaw.length > 0) {
    data = chartDataRaw;
    if (spot) {
      if (changeFields === true) {
        data[data.length - 1].close_currency = spot;
        data[data.length - 1].settle_currency = spot;
        data[data.length - 1].high_currency = Math.max(
          spot,
          data[data.length - 1].high_currency,
        );
        data[data.length - 1].low_currency = Math.min(
          spot,
          data[data.length - 1].low_currency,
        );
      } else {
        data[data.length - 1].close = spot;
        data[data.length - 1].settle = spot;
        data[data.length - 1].high = Math.max(spot, data[data.length - 1].high);
        data[data.length - 1].low = Math.min(spot, data[data.length - 1].low);
      }
    }
  }
  return data;
};

ProcessData.prototype.includeSpotNew = function(
  chartDataRaw,
  spotData,
  changeFields = false,
  isCommodity = false,
) {
  let data = [];
  if (chartDataRaw.length > 0) {
    data = chartDataRaw;
    if (spotData) {
      const isEndpointBack = !spotData.close;
      const observationDate = this.getObservationDate(
        spotData,
        isEndpointBack,
        isCommodity,
      );
      const key = isCommodity ? "last_price" : "last";
      const close = spotData[isEndpointBack ? key : "close"];
      const open = spotData[isEndpointBack ? key : "open"];
      if (+chartDataRaw.at(-1).date < +observationDate.setHours(0, 0, 0, 0)) {
        // Add last date
        data.push({
          date: new Date(observationDate),
          close: close,
          settle: close,
          open: open,
          high: Number.isNaN(spotData.high)
            ? Math.max(open, close)
            : spotData.high,
          low: Number.isNaN(spotData.low)
            ? Math.min(open, close)
            : spotData.low,
        });
      } else {
        this.updateData(data, close, changeFields, observationDate, spotData);
      }
    }
  }
  return data;
};

ProcessData.prototype.getObservationDate = function(
  spotData,
  isEndpointBack,
  isCommodity,
) {
  const dateKey = isCommodity ? "last_observation_date" : "observation_time";
  const timeKey = "time";
  const dateTime = spotData[isEndpointBack ? dateKey : timeKey];
  const includesTime = this.isValidTime(dateTime);
  const addHours = !includesTime ? "T00:00:00" : "";
  const date = new Date(`${dateTime}${addHours}`);
  return date;
};

ProcessData.prototype.isValidTime = function(timeString) {
  const regex = /\d{2}:\d{2}:\d{2}/g;
  return regex.test(timeString);
};

ProcessData.prototype.updateData = function(
  data,
  close,
  changeFields,
  observationDate,
  spotData,
) {
  const lastData = data.at(-1);
  if (changeFields === true) {
    lastData.close_currency = close;
    lastData.settle_currency = close;
    lastData.high_currency = Math.max(close, lastData.high_currency);
    lastData.low_currency = Math.min(close, lastData.low_currency);
  } else if (+lastData.date === +observationDate.setHours(0, 0, 0, 0)) {
    // update last date
    const high = spotData.high ? spotData.high : lastData.high;
    const low = spotData.low ? spotData.low : lastData.low;
    lastData.close = +close;
    lastData.settle = +close;
    lastData.high = Math.max(+close, +high);
    lastData.low = Math.min(+close, +low);
  }
};

ProcessData.prototype.percentile = function(sortedData, q) {
  sortedData = sortedData.filter((x) => !!x);
  let n = sortedData.length;
  let r = q * n;
  let k = Math.floor(r + 0.5);
  let kp1 = k + 1;
  r = r - k;
  k = Math.max(0, k - 1);
  kp1 = Math.min(kp1 - 1, n - 1);
  let y = (0.5 + r) * sortedData[kp1] + (0.5 - r) * sortedData[k];
  // Make sure that values we hit exactly are copied rather than interpolated
  let exact = r === -0.5;
  if (exact === true) {
    y = sortedData[k];
  }
  // Make sure that identical values are copied rather than interpolated
  let same = sortedData[k] === sortedData[kp1];
  if (same === true) {
    y = sortedData[k];
  }

  return y;
};

ProcessData.prototype.mapFieldName = function(data, field) {
  return data.map((d) => ({
    date: d["date"],
    value: Number.isFinite(+d[field]) ? +d[field] : null,
  }));
};

ProcessData.prototype.mapUpperLowerFieldsName = function(
  data,
  upperField,
  lowerField,
) {
  return data.map((d) => ({
    date: d["date"],
    upper: Number.isFinite(+d[upperField]) ? +d[upperField] : null,
    lower: Number.isFinite(+d[lowerField]) ? +d[lowerField] : null,
  }));
};

ProcessData.prototype.toSlice = function(data, selectedDaysCandle) {
  return data.slice(-selectedDaysCandle - 1);
};

ProcessData.prototype.closestNum = function(array, needle) {
  if (array.length === 0) return -1;
  let i = array.length - 1;
  let sw = true;
  while (sw) {
    if (i === 0) {
      return 0;
    }
    if (array[i] > needle) {
      i = i - 1;
    } else if (array[i] <= needle) {
      return i;
    }
  }
  return 0;
};

ProcessData.prototype.minMax = function(
  data,
  fieldHigh,
  fieldLow,
  result = [Infinity, -Infinity],
  toZero = false,
) {
  if (data.length > 0) {
    result[0] = Math.min(
      result[0],
      min(data, function(d) {
        return Number.isFinite(d[fieldLow]) &&
          d[fieldLow] != null &&
          d[fieldLow] !== undefined
          ? +d[fieldLow]
          : Infinity;
      }),
    );
    result[1] = Math.max(
      result[1],
      max(data, function(d) {
        return Number.isFinite(d[fieldHigh]) &&
          d[fieldLow] != null &&
          d[fieldLow] !== undefined
          ? +d[fieldHigh]
          : -Infinity;
      }),
    );
    if (toZero) {
      result[0] = Math.min(0, result[0]);
      result[1] = Math.max(1, result[1]);
    }
  }
  return result;
};

ProcessData.prototype.ohlcNest = function(data, intervalCandle, includeId) {
  var _this = this;
  function timeCompareCandle(dat, intervalCandle) {
    let dateFn;
    if (intervalCandle === "week") {
      dateFn = timeMonday(dat);
    } else if (intervalCandle === "weekYear") {
      dateFn = _this.weekYear(dat);
    } else if (intervalCandle === "month") {
      dateFn = timeMonth(dat);
    } else if (intervalCandle === "day") {
      dateFn = dat;
    } else {
      dateFn = dat;
    }
    return dateFn;
  }
  let dat = nest()
    .key(function(d) {
      if (d !== null && d !== undefined)
        return timeCompareCandle(d.date, intervalCandle);
    })
    .rollup(function(v) {
      let date = timeCompareCandle(values(v).pop().date, intervalCandle);
      let open = values(v).shift().open;
      let low = min(v, function(d) {
        return d.low;
      });
      let high = max(v, function(d) {
        return d.high;
      });
      let close = values(v).pop().close;
      let ave = mean(v, function(d) {
        return d.close;
      });
      return {
        date: date,
        open: open,
        low: low,
        high: high,
        close: close,
        ave: ave,
      };
    })
    .entries(data)
    .map(function(d) {
      return d.value;
    });

  if (includeId) {
    dat.forEach(function(d) {
      d.id = +d.date;
    });
  }

  return dat;
};

ProcessData.prototype.average = function(data) {
  return data.reduce((a, b) => a + b) / (data.length || 1);
};

ProcessData.prototype.makeWindow = function(before, after) {
  return function(_number, index, array) {
    const start = Math.max(0, index - before + 1);
    const end = Math.min(array.length, index + after + 1);
    return _.slice(array, start, end);
  };
};

ProcessData.prototype.movingAverage = function(data, before = 20, after = 0) {
  return _.chain(data)
    .map(this.makeWindow(before, after))
    .map(this.average)
    .value();
};

ProcessData.prototype.bollinger = function(data, before = 20, after = 0) {
  var bands = [];
  for (var i = 0, len = data.length; i < len; i++) {
    var slice = data.slice(
      Math.max(0, i - before + 1),
      Math.min(i + after + 1, data.length),
    );
    var ave = mean(slice, function(d) {
      return d.close;
    });
    var stdDev = Math.sqrt(
      mean(
        slice.map(function(d) {
          return Math.pow(d.close - ave, 2);
        }),
      ),
    );
    bands.push({
      date: data[i].date,
      bband_ma: ave,
      bband_l1: ave - stdDev,
      bband_l2: ave - 2 * stdDev,
      bband_u1: ave + stdDev,
      bband_u2: ave + 2 * stdDev,
    });
  }
  return bands;
};

ProcessData.prototype.rsi = function(data, period = 14) {
  let nData = data.length;
  if (nData < period) {
    return null;
  } // length/period check
  var rsi = [50],
    gains = [0],
    losses = [0],
    dif = 0,
    avg_gain = 0,
    avg_loss = 0,
    sliceG = [],
    sliceL = [];

  for (var i = 1, len = data.length; i < len; i++) {
    dif = data[i].close - data[i - 1].close;
    if (dif >= 0) {
      gains.push(dif);
      losses.push(0);
    } else {
      gains.push(0);
      losses.push(-dif);
    }
    if (i === period) {
      sliceG = gains.slice(
        Math.max(1, i - period + 1),
        Math.min(i + 1, data.length),
      );
      sliceL = losses.slice(
        Math.max(1, i - period + 1),
        Math.min(i + 1, data.length),
      );
      avg_gain = mean(sliceG, function(d) {
        return d;
      });
      avg_loss = mean(sliceL, function(d) {
        return d;
      });
      avg_loss === 0
        ? rsi.push(100)
        : rsi.push(100 - 100 / (1 + avg_gain / avg_loss));
    } else if (i > period) {
      // Wilder’s Smoothing Method, https://www.macroption.com/rsi-calculation/
      avg_gain = (avg_gain * (period - 1) + gains[i]) / period;
      avg_loss = (avg_loss * (period - 1) + losses[i]) / period;
      avg_loss === 0
        ? rsi.push(100)
        : rsi.push(100 - 100 / (1 + avg_gain / avg_loss));
    } else {
      rsi.push(50);
    }
  }
  return rsi;
};

ProcessData.prototype.macd = function(data, n1 = 12, n2 = 26, n3 = 9) {
  // https://www.investing.com/education/terms/macd-200423772?utm_source=google&utm_medium=cpc&utm_campaign=13686300625&utm_content=541730250157&utm_term=dsa-19959388920_&GL_Ad_ID=541730250157&GL_Campaign_ID=13686300625&gclid=Cj0KCQjwqKuKBhCxARIsACf4XuEdXOwaDzNgXqqKbdJPgpu4FB5OvtyTbTlgXhHV1DLutN8yXyNOW88aAnCsEALw_wcB
  let period = Math.max(n1, n2, n3);
  let nData = data.length;
  if (nData < period) {
    return null;
  } // length/period check
  let md1 = ema(data, n1);
  let md2 = ema(data, n2);
  let md = [];
  md1.forEach(function(d, i) {
    md.push(d - md2[i]);
  });
  let signal = ema(md, n3);
  let histo;
  let macd = [];
  md.forEach(function(d, i) {
    histo = d - signal[i];
    macd.push({ macd: md[i], signal: signal[i], histogram: histo });
  });
  return macd;
};

ProcessData.prototype.stoch = function(data, n1 = 14, n2 = 3) {
  // https://en.wikipedia.org/wiki/Stochastic_oscillator
  let period = Math.max(n1, n2);
  let nData = data.length;
  if (nData < period) {
    return null;
  } // length/period check
  // Create the "L14" and "H14" column in the DataFrame in lowHi
  let loHi = rollingMaxMin(data, n1, "low", "high");
  // Create the "%K" or pK column in the DataFrame
  let pK = [];
  data.forEach(function(d, i) {
    pK.push((100 * (d.close - loHi[i].min)) / (loHi[i].max - loHi[i].min));
  });
  // Create and return the "%D" or pD
  let pD = this.movingAverage(pK, n2, 0);
  let stoch = [];
  pK.forEach(function(d, i) {
    stoch.push({ pK: d, pD: pD[i] });
  });
  return stoch;
};

ProcessData.prototype.fibonacciReset = function() {
  return {
    short: { num: 1, minMax: [] },
    medium: { num: 1, minMax: [] },
    long: { num: 1, minMax: [] },
  };
};

ProcessData.prototype.fiboLowHighToPrices = function(p1, p2, pxPercent) {
  let px = JSON.parse(JSON.stringify(pxPercent));
  for (let i = 0; i < pxPercent.length; i++) {
    px[i] = (1 - pxPercent[i]) * p1 + pxPercent[i] * p2;
  }
  return px;
};

ProcessData.prototype.fibonacciMinMax = function(data) {
  let fibonacci = this.fibonacciReset();
  fibonacci["short"].minMax = data
    .map((d, i) =>
      d.find_min_short != null || d.find_max_short != null ? i : null,
    )
    .filter((d) => d != null);
  fibonacci["medium"].minMax = data
    .map((d, i) =>
      d.find_min_medium != null || d.find_max_medium != null ? i : null,
    )
    .filter((d) => d != null);
  fibonacci["long"].minMax = data
    .map((d, i) =>
      d.find_min_long != null || d.find_max_long != null ? i : null,
    )
    .filter((d) => d != null);
  return fibonacci;
};

ProcessData.prototype.dataPrepMultiLines = function(
  name,
  subString,
  keys,
  data,
  xField,
) {
  return {
    y: name,
    series: keys.map((d) => ({
      name: d
        .replace(/, ([\w-]+).*/, " $1")
        .substring(subString.length)
        .toUpperCase(),
      values: data.map((k) => k[d]),
    })),
    dates: data.map((k) => k[xField]),
  };
};

ProcessData.prototype.indexOfMin = function(arr) {
  if (arr.length === 0) {
    return -1;
  }
  var min = 100000000000000;
  var minIndex = 0;
  for (var i = 0; i < arr.length; i++) {
    if (isFinite(arr[i])) {
      if (arr[i] < min) {
        minIndex = i;
        min = arr[i];
      }
    }
  }
  return minIndex;
};

ProcessData.prototype.setD3ColorFunction = function(colorSel, domain) {
  let nColorSelection = colorSel.length;
  let deltaCol = 2 / (nColorSelection - 1);
  let interp = scaleLinear()
    .domain(range(0, nColorSelection + 1).map((i) => -1 + i * deltaCol))
    .range(colorSel)
    .interpolate(interpolateRgb);
  colorSel = domain.map((d) => interp(d));
  return scaleLinear()
    .domain(domain)
    .range(colorSel)
    .interpolate(interpolateRgb); //interpolateHsl interpolateHcl interpolateRgb;
};

ProcessData.prototype.createWorkingDays = function(start, end) {
  let dat;
  for (
    var arr = [], dt = new Date(start);
    dt <= end;
    dt.setDate(dt.getDate() + 1)
  ) {
    dat = new Date(dt);
    if (dat.getDay() > 0 && dat.getDay() < 6) {
      arr.push(new Date(dt));
    }
  }
  return arr;
};

ProcessData.prototype.createWeekByWeekDays = function(start, end) {
  for (
    var arr = [], dt = new Date(start);
    dt <= end;
    dt.setDate(dt.getDate() + 7)
  ) {
    arr.push(new Date(dt));
  }
  return arr;
};

ProcessData.prototype.createNDays = function(start, n) {
  let arr = [];
  let dt = new Date(start);
  let days = 1;
  for (let i = 0; i < n; i++) {
    days = dt.getDay() === 5 ? 3 : 1;
    dt.setDate(dt.getDate() + days);
    arr.push({ date: new Date(dt) });
  }
  return arr;
};

ProcessData.prototype.createNWeeks = function(start, n, sign = "+") {
  let arr = [];
  let dt = new Date(start);
  for (let i = 0; i < n; i++) {
    dt.setDate(dt.getDate() + (sign === "+" ? 7 : -7));
    arr.push({ date: new Date(dt) });
  }
  return arr;
};

ProcessData.prototype.createNMonths = function(start, n) {
  let arr = [];
  let dt = new Date(start);
  for (let i = 0; i < n; i++) {
    dt.setMonth(dt.getMonth() + 1);
    arr.push({ date: new Date(dt) });
  }
  return arr;
};
